module.exports = __webpack_public_path__ + "img/roleDistributionNoData.be477e89.svg";